module.exports = "https://dashboard.cdn.gifty.nl/6189/images/fingerprint-bg.svg?f368a7115c7e3ff8f115643f19856037";